import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-text',
  templateUrl: 'text.component.html',
  styleUrls: ['text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViTextComponent {
  @Input() size: String = 'normal';
  @Input() color: String = 'primary';
  @Input() weight: string = 'regular';
  @Input() content: string;
}
